require('./mortgageRequestView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { includes } = require('lodash/collection');
const PropTypes = require('prop-types');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilities
const { webappClassName } = require('utilities/conditionals/conditionalClassname')
const { recordLinkV2 } = require("utilities/tagging");

// @actions
const stateActions = require('actions/mortgageRequest/mortgageRequestState');
const simulationActions = require('actions/mortgageRequest/mortgageRequestSimulationLinkClient');
const mortgageRequestDataAction = require('actions/mortgageRequest/mortgageRequestMortgageData');

// @ constants
const mortgageRequestStates = require('constants/mortgageRequestStates');

const SIMULATION_STATES = [
    mortgageRequestStates.SIMULACION,
    mortgageRequestStates.RESULTADO_SIMULACION,
    mortgageRequestStates.PRE_APROBACION,
    mortgageRequestStates.TASA_ESF_KO,
    mortgageRequestStates.SIN_EXPEDIENTE,
    mortgageRequestStates.ANULADO,
    mortgageRequestStates.PRE_APROBADO
]


class MortgageRequestView extends React.Component {
    constructor(props) {
        super(props);
        this.validStatus = this.validStatus.bind(this);
        this.path = {
            profile: '/myprofile',
            simulation: '/myprofile/mortgage/simulation',
            global: '/myprofile/global',
            manager: '/myprofile/mortgage/manager',
            panel: '/myprofile/mortgage/panel',
            denied: '/myprofile/mortgage/mortgage-denial',
            error: '/myprofile/mortgage-error',
            preapproval: '/myprofile/mortgage/pre-approval',
            welcomeRNC: '/myprofile/mortgage/welcome-rnc',
            documentation: '/myprofile/mortgage/documentation'
        };

        this.post_signature = [
            '/myprofile/mortgage/amortization-plan',
            '/myprofile/mortgage/operative-general-data'
        ];

        this.state = {
            children: <LoadingSection />
        };
    }

    componentDidMount() {
        const { history, match: { params: { token } }, requestState, linkClient, immGlobalPosition } = this.props;
        requestState(undefined, history);

        if (includes(history.location.pathname, this.path.simulation)) {
            if (!!token) {
                const isClient = !immGlobalPosition.get('isClientWithoutAccounts');
                linkClient(token, isClient, history);
                recordLinkV2({fireEventName: "mortgage_approved_client_access"});               
            } else {
                history.push(this.path.profile);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { mortgageRequestState, requestMortgageData } = this.props;

        if (mortgageRequestState !== prevProps.mortgageRequestState) {
            const currentStatus = mortgageRequestState.get('estado');
            if (currentStatus && SIMULATION_STATES.indexOf(mortgageRequestState.get('estado')) === -1) {
                requestMortgageData();
            }
        }
    }

    componentWillUnmount(){
        this.props.resetMortgageRequestState();
    }

    validStatus(currentStatus) {
        const { history, immGlobalPosition, linkClient } = this.props;
        const isClient = !immGlobalPosition.get('isClientWithoutAccounts');
        const estado = currentStatus.get('estado');
        const tokenSimulacion = currentStatus.get('token');
        const currentPath = history.location.pathname;
        let realPath;

        switch (estado) {
            case mortgageRequestStates.SIMULACION:
            case mortgageRequestStates.RESULTADO_SIMULACION:
            case mortgageRequestStates.PRE_APROBACION:
            case mortgageRequestStates.TASA_ESF_KO:
            case mortgageRequestStates.SIN_EXPEDIENTE:
            case mortgageRequestStates.ANULADO:
                realPath = this.path.preapproval;
                break;
            case mortgageRequestStates.PRE_APROBADO:
                if (!isClient && tokenSimulacion !== '') {
                    linkClient(tokenSimulacion, isClient, history);
                    realPath = currentPath;
                } else {
                    realPath = this.path.preapproval;
                }
                break;
            case mortgageRequestStates.SOLIC_PRESTAMO:
                if (currentPath === this.path.documentation) {
                    realPath = this.path.documentation;
                } else {
                    realPath = this.path.manager;
                }
                break;
            case mortgageRequestStates.APORTAR_DOC:
            case mortgageRequestStates.AUT_CIRBE:
            case mortgageRequestStates.AUT_CIRBE_CO:
            case mortgageRequestStates.WAIT_CIRBE_COT:
            case mortgageRequestStates.DATOS_VIV:
            case mortgageRequestStates.TRAMITAR_NS:
            case mortgageRequestStates.WAIT_NS:
            case mortgageRequestStates.PROBLEMA_NS:
            case mortgageRequestStates.PEND_TASACION:
            case mortgageRequestStates.TRAMITAR_TAS:
            case mortgageRequestStates.WAIT_DICTAMEN:
            case mortgageRequestStates.ANALISIS_TAS:
            case mortgageRequestStates.APROBADO_RIESGOS:
            case mortgageRequestStates.GENERANDO_OV:
            case mortgageRequestStates.PROV_FONDOS:
            case mortgageRequestStates.PEND_MMPP:
            case mortgageRequestStates.PEND_SALDO:
            case mortgageRequestStates.PEND_FIRMA:
            case mortgageRequestStates.FIRMADO:
            case mortgageRequestStates.OFRECER_FINANCIACION_GASTOS:
            case mortgageRequestStates.CONFIRMA_DATOS_T2:
            case mortgageRequestStates.APERTURA_CUENTA:
            case mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR:
            case mortgageRequestStates.ESPERA_DOC_FIRMA:
            case mortgageRequestStates.ESPERA_ACTA_NOTARIO:
            case mortgageRequestStates.GESTION_FECHA_FIRMA:
                if (currentPath === this.path.denied || currentPath === this.path.manager) {
                    realPath = this.path.panel;
                } else {
                    realPath = currentPath;
                }
                break;
            case mortgageRequestStates.MODEL_CORRECT:
            case mortgageRequestStates.ERROR_BUREAUS:
                realPath = this.path.denied;
                break;
            default:
                if (!estado && currentPath === this.path.preapproval) {
                    realPath = currentPath;
                } else {
                    realPath = this.path.global;
                }
                break;
        }

        if (currentPath !== realPath) {
            history.push(realPath);
        } else {
            return true;
        }

        return false;
    }

    buildContent() {
        const { mortgageRequestState, immMortageRequestSimulationLinkClient, children } = this.props;
        const isFetching = mortgageRequestState.get('isFetching');
        const simulationLinkClientIsFetching = immMortageRequestSimulationLinkClient.get('isFetching');
        const hasBeenFetched = mortgageRequestState.get('hasBeenFetched');

        let content;
        if (isFetching || !hasBeenFetched || simulationLinkClientIsFetching || !children) {
            content = <LoadingSection />;
        } else {
            const isValidStatus = this.validStatus(mortgageRequestState);
            if (isValidStatus) {
                content = children;
            }
        }

        return content;
    }

    render() {
        const content = this.buildContent();
        const gridClass = webappClassName('grid-view');

        return (
            <div className={gridClass}>
                {content}
            </div>
        );
    }
}

MortgageRequestView.propTypes = {
    children: PropTypes.object,
    match: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    linkClient: PropTypes.func,
    saveRNCPersonalData: PropTypes.func,
    requestState: PropTypes.func,
    cargaInicial: PropTypes.func,
    requestMortgageData: PropTypes.func,
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immMortageRequestSimulationLinkClient: PropTypes.object,
    resetMortgageRequestState: PropTypes.func,
};

module.exports.constructor = MortgageRequestView;
module.exports.MortgageRequestView = connect(state => ({
    mortgageRequestState: state.mortgageRequestState,
    immGlobalPosition: state.globalPosition,
    immMortageRequestSimulationLinkClient: state.mortgageRequestSimulationLinkClient,
}), {
    linkClient: simulationActions.linkClient,
    saveRNCPersonalData: simulationActions.savePersonalData,
    requestState: stateActions.requestState,
    cargaInicial: stateActions.cargaInicial,
    requestMortgageData: mortgageRequestDataAction.requestMortgageData,
    resetMortgageRequestState: stateActions.resetMortgageRequestState,
})(withRouter(MortgageRequestView));
